export const nullableNumber = (value: unknown, originalValue: unknown) =>
  originalValue === "" ? null : value;
